import { render, staticRenderFns } from "./MyFirstComponent.vue?vue&type=template&id=3f2fd424&scoped=true"
import script from "./MyFirstComponent.vue?vue&type=script&lang=js"
export * from "./MyFirstComponent.vue?vue&type=script&lang=js"
import style0 from "./MyFirstComponent.vue?vue&type=style&index=0&id=3f2fd424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2fd424",
  null
  
)

export default component.exports